(function () {
  function customonload() {    
    var myButton = document.querySelector('.shopify-payment-button__more-options');
    if (myButton) {
      myButton.textContent = 'Buy Now';
      myButton.classList.add('show');
     // myButton.style.display = 'block';
    }
     myButton.addEventListener('click', function() {
      // Your action or code here
      // console.log('Button clicked!');
       // myButton.style.display = 'none';
      myButton.classList.remove('show');
    });
  }
  document.addEventListener('shopify:section:load', customonload);
  window.addEventListener('load', customonload);
})();